import React from 'react';
import styles from './style.module.css';
import Typography from '../../components/Typography/Typography';
import { DiscoverCloset } from '../../assets/webp';

export const DiscoverSection: React.FC = () => {
    const features = [
        {
            title: 'Built to Scale with You',
            description: 'From AI guidance to 3D previews and secure checkout, Open3X gives you the tools to grow without the complexity.',
        },
        {
            title: 'Explore in 3D',
            description: 'Step into virtual stores or browse in a simple top view — no login needed. Shop art, fashion, and culture from Africa’s finest creators.',
        },
        {
            title: 'Start Selling in Minutes',
            description: 'Turn your products into a virtual store with just a few clicks. No dashboard, no delay — just upload, customize, and go live.',
        },
    ];

    return (
        <section className={styles.discoverContainer}>
            <div className={styles.discoverSection}>
                <div className={styles.discoverHeader}>
                    <Typography
                        variant="heading2"
                        fontFamily="satoshi"
                        weight="bold"
                        className={styles.title}
                    >
                        Discover What’s Possible
                    </Typography>
                </div>
                <div className={styles.discoverSubtitle}>
                    <Typography
                        variant="bodyRegular"
                        fontFamily="satoshi"
                        weight="regular"
                        className={styles.subtitle}
                    >
                        Buy, Sell and learn about products and arts with 3D display<br />
                        all at your comfort, We bring the real world to you
                    </Typography>
                </div>

                <div className={styles.imageWrapper}>
                    <img
                        src={DiscoverCloset}
                        alt="Virtual Closet"
                        className={styles.mainImage}
                    />

                    <div className={styles.featureOverlayContainer}>
                        {features.map((feature, index) => (
                            <div key={index} className={styles.featureBox}>
                                <Typography
                                    variant="bodyLarge"
                                    fontFamily="satoshi"
                                    weight="bold"
                                    size='base'
                                    className={styles.featureTitle}>
                                    {feature.title}
                                </Typography>
                                <Typography
                                    variant="bodyRegular"
                                    fontFamily="helvetica"
                                    weight="regular"
                                    size='base'
                                    className={styles.featureDescription}>
                                    {feature.description}
                                </Typography>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.discoverFooter}>
                    <Typography
                        variant="bodyRegular"
                        fontFamily="satoshi"
                        weight="regular"
                        className={styles.footerText}
                    >
                        All from your comfort, using your mobile device, computer, or a VR headset.
                    </Typography>
                </div>
            </div>
        </section>
    );
};
